import { useState, useRef } from "react";

const useBringValue = (props) => {
  const [datakey, setDatakey] = useState(null);
  // const [searchValue, setSearchValue] = useState("");
  // const [searchField, setSearchField] = useState("");
  // const [additionalFilter, setAdditionalFilter] = useState("");
  // const [multiSelect, setMultiSelect] = useState(false);
  const [title, setTitle] = useState("");
  const [gridData, setGridData] = useState([]);
  const ref = useRef();
  const gridRef = useRef();
  const popupRef = useRef();

  const gridInitialized = (flex) => {
    flex.stickyHeaders = true;
    flex.selectionMode = "Row";
    flex.keyActionEnter = "None";
    flex.isReadOnly = true;
    gridRef.current = flex;
    // const view = flex.collectionView;
    flex.hostElement.addEventListener("dblclick", (e) => {
      let ht = flex.hitTest(e.pageX, e.pageY);
      const view = ht?.grid?.collectionView;
      const currentItem = view.currentItem;
      if (currentItem && ht.cellType === 1) {
        /* Runs handle select */
        ref.current.callback(view.currentItem);
        popupRef?.current?.hide();
        setDatakey(null);
        setGridData(null);
      }
    });

    flex.hostElement.addEventListener("keydown", (e) => {
      const view = flex.collectionView;
      if (e.code === "Enter" && view.currentItem) {
        e.preventDefault();
        e.stopPropagation();
        /* Runs handle select */
        ref.current.callback(view.currentItem);
        popupRef?.current?.hide();
        setDatakey(null);
        setGridData(null);
      }
    });
  };

  const popupInitialized = (popup) => {
    popup.isDraggable = true;
    popup.isResizable = true;
    popup.fadeOut = false;
    popup.fadeIn = false;

    popupRef.current = popup;
  };

  const selectItem = (select) => {
    if (select)
      ref?.current?.callback(gridRef.current?.collectionView?.currentItem);
    else ref?.current?.callback("BringValue canceled no item selected");
    popupRef?.current?.hide();
    setDatakey(null);
    setGridData(null);
  };

  return {
    gridInitialized,
    popupInitialized,
    ref,
    gridRef,
    popupRef,
    datakey,
    setDatakey,
    title,
    setTitle,
    // setSearchValue,
    // setSearchField,
    // setAdditionalFilter,
    // setMultiSelect,
    gridData,
    setGridData,
    selectItem,
  };
};

export default useBringValue;
